package com.ilussobsa.views.dialogs

import com.ilussobsa.Strings
import com.lightningkite.kiteui.models.Align
import com.lightningkite.kiteui.models.KeyboardHints
import com.lightningkite.kiteui.models.SizeConstraints
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.dialogPageNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

class SendEmailDialog(val onConfirm: (suspend (String) -> Unit)) : Page {

    val message = Signal<String>("")
    override fun ViewWriter.render() = dismissBackground {
        centered - sizedBox(SizeConstraints(maxWidth = 50.rem, minWidth = 20.rem)) - card - scrolls -col {
            text {
                align = Align.Center
                content = "Ask us a Question"
            }
            card - textArea {
                keyboardHints = KeyboardHints.paragraph
                hint = "Type your vehicle inquiry here..."

                content bind message
            }
            row {
                card - button {
                    text {
                        align = Align.Center
                        content = Strings.cancel
                    }
                    onClick {
                        dialogPageNavigator.dismiss()
                    }
                }
                expanding - space()
                card - button {
                    text {
                        align = Align.Center
                        content = "Send Inquiry Email"
                    }
                    onClick {
                        onConfirm.invoke(message())
                        dialogPageNavigator.dismiss()
                    }
                }
            }
        }
    }
}